import LocationProfile from "../LocationProfile";

type LocationProfileContainerProps = {
  profile: string
};

const LocationProfileContainer = ({
  profile,
}: LocationProfileContainerProps) => {
  return (
    <LocationProfile
      prefix={profile}
    />
  );
};

export default LocationProfileContainer;
